import {DomainEvent} from './DomainEvent';

interface EntitiesForDistrictRequest {
  /** ID of the district, where the entities are linked to */
  readonly districtId: number;
  /** name of an S3 bucket where the data shall be put in batches */
  readonly targetBucket: string;
  /** prefix for the batches within the bucket */
  readonly transactionId: string;
  /** number of entities within a batch file, default: 500 */
  readonly batchSize?: number;
}

/**
 * Base class for events that can be fired to indicate, that a services requires entities linked to a certain district.
 * Another service, that is eligible to provide this info will put batches of the requested data into
 * the specified S3 `targetBucket`, using the `transactionId` as prefix (subfolder).
 */
export abstract class EntitiesForDistrictRequested extends DomainEvent<EntitiesForDistrictRequest> {}
